export default {
  get() {
    return Promise.resolve({
      userId: '6e5ec7ce-dd41-4de9-9b5b-6842b2a5c447',
      companyCode: '002',
      loginId: 'cyber-taro',
      roles: ['admin'],
    })
  },
}
